import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, Redirect } from 'react-router-dom';
import { Alert, ListGroup, ListGroupItem } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as Studies from '../store/Studies';
import * as utility from '../data/Utility';


class SelectStudyInternal extends React.Component {
    constructor(props) {
        super(props);

        var returnPath;

        if (this.props.accountsState && this.props.accountsState.authenticatedAccount && (this.props.accountsState.authenticatedAccount.role === Accounts.accountRoles.Administrator)) {
            returnPath = utility.propCheck(props.returnPath, paths.dashboard);
        } else {
            returnPath = utility.propCheck(props.returnPath, paths.selectRecord);
        }

        this.state = {
            returnPath: returnPath,
        };
	}

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
	}

    createListGroup(studies) {
        const listItems = studies.map(study => {
            const studyName = study.name;
            return (
                <ListGroupItem key={study.id} tag={Link} to={{ pathname: this.state.returnPath, state: { studyId: study.id, studyName: studyName } }} title={studyName} action>
                    {studyName}
                </ListGroupItem>
            );
        });
        return (
            <ListGroup>
                {listItems}
            </ListGroup>
        );
    }

    render() {
        if ( ! Accounts.authenticatedAllRoles(this.props.accountsState) ) {
            return (
                <NotAuthenticated />
            );
		}

        const authenticatedAccount = this.props.accountsState.authenticatedAccount;
        var error = false;
        var message = "";
        var selectRecord = false;
        var studyId = "";
        var studyList = null;
        var studyName = "";

        if (authenticatedAccount != null) {
            const studies = authenticatedAccount.studies;
            if (studies != null &&
                studies.length != null &&
                studies.map != null) {
                studyList = this.createListGroup(studies);
                if (studies.length <= 0) {
                    message = "This account is not linked to any studies.";
                }
                else if (studies.length === 1) {
                    selectRecord = true;
                    const study = studies[0];
                    studyId = study.id;
                    studyName = study.name;
                }
            }
            else {
                error = true;
                message = "Error retrieving studies.";
            }

			if ( ! this.state.returnPath ) {
				if ( this.props.accountsState && this.props.accountsState.authenticatedAccount && (this.props.accountsState.authenticatedAccount.role === Accounts.accountRoles.Administrator) ) {
					this.setState({ returnPath: paths.dashboard });
				} else {
					this.setState({ returnPath: paths.selectRecord });
				}
			}
        }
        else {
            error = true;
            message = "Error retrieving account.";
        }

        const alertColor = error ? "danger" : "primary";
        const displayMessage = message !== "";

        return (
            <div>
                {selectRecord && <Redirect to={{ pathname: this.state.returnPath, state: { studyId: studyId, studyName: studyName } }} />}
                <h1>Select Study</h1>
                <br />
                {displayMessage && <Alert color={alertColor}>{message}</Alert>}
                {studyList}
            </div>
        );
    }
}

const SelectStudyConnect = connect(
    state => ({
        accountsState: state.accounts,
        studiesState: state.studies
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        studiesDispatch: bindActionCreators(Studies.actionCreators, dispatch)
    })
)(SelectStudyInternal);

export default class SelectStudy extends React.Component {
    constructor(props) {
        super(props);

		let returnPath = props.location.state && props.location.state.returnPath;

        this.state = {
            returnPath: returnPath,
		};
	}

    render() {
        return (
            <ErrorBoundary>
                <SelectStudyConnect returnPath={this.state.returnPath}/>
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SelectStudy.js